import { Component, OnInit } from "@angular/core";
import moment from "moment-timezone";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { ImportFile } from "src/app/shared/models/focusDataModels/ImportFile";

@Component({
	selector: "app-data-import-history",
	templateUrl: "./data-import-history.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class DataImportHistoryComponent implements OnInit {
	dataImportFiles: ImportFile[];
	dataImportFileSelected: ImportFile;

	requestRepollDisplay: boolean = false;
	requestRepollDate;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusData: FocusdataService,
		public imgCrop: ImageCropperService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		this.dataImportFilesGet(this.venueService.subscriptionVenue.value.key);
	}

	async dataImportFilesGet(venueKey) {
		const resp = await this.focusData.dataImportFileGet(venueKey);
		const importFiles: ImportFile[] = resp.map((i) => {
			return new ImportFile(i);
		});
		this.dataImportFiles = importFiles.sort((a, b) => (moment(a.checkDate, "MMDDYYYY").unix() < moment(b.checkDate, "MMDDYYYY").unix() ? 1 : -1));
	}

	async dataImportFileGetOne(fileName: string) {
		const resp = await this.focusData.dataImportFileGetOne(this.venueService.subscriptionVenue.value.key, fileName);
		this.dataImportFileSelected = new ImportFile(resp);
	}

	async dataImportFileDeleteOne(fileName: string) {
		await this.focusData.dataImportFileDeleteOne(this.venueService.subscriptionVenue.value.key, fileName);
		this.dataImportFiles.splice(
			this.dataImportFiles.findIndex((i) => i.fileName === fileName),
			1
		);
		this.dataImportFiles = [...this.dataImportFiles];
	}

	async requestRepoll() {
		const repollDate = this.app.moment(this.requestRepollDate).format("YYYY-MM-DD");
		try {
			await this.focuslink.datafeedRepoll(this.venueService.subscriptionVenue.value.key, repollDate);
			this.app.msgSvc.add({
				severity: AppMessageSeverity.GREEN,
				summary: "",
				detail: `Repoll request submitted. Please allow up to 5 minutes for processing.`,
			});
		} catch (error) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `message` });
		}
	}
}
